import DriverRoute from "./DriverRoute";

const RouteLines = ({ drivers, mapRef }) => {
  return (
    <>
      {drivers.map((driver) => (
        <DriverRoute
          key={`${driver.driverId}-${driver.routeKey || 0}`}
          driver={driver}
          mapRef={mapRef}
        />
      ))}
    </>
  );
};

export default RouteLines;
